import React from "react";
import ClauseBuilder from "./ClauseBuilder";

const ConditionGroup = ({ group, setGroup, fields, isRoot = false, onRemove,onReset }) => {
  
   const hasConditions = group.conditions.length > 0;
   const canReset = hasConditions || group.operator !== "AND";
  const handleClauseChange = (index, updatedClause) => {
    const updated = [...group.conditions];
    updated[index] = updatedClause;
    setGroup({ ...group, conditions: updated });
  };

  const handleClauseDelete = (index) => {
    const updated = group.conditions.filter((_, i) => i !== index);
    setGroup({ ...group, conditions: updated });
  };

  const handleAddClause = () => {
    const newClause = {
      column: "",
      op: "=",
      value: "",
      type: "STRING"
    };
    setGroup({ ...group, conditions: [...group.conditions, newClause] });
  };

  const handleAddGroup = () => {
    const newGroup = { operator: "AND", conditions: [] };
    setGroup({ ...group, conditions: [...group.conditions, newGroup] });
  };

  const handleGroupChange = (index, updatedSubGroup) => {
    const updated = [...group.conditions];
    updated[index] = updatedSubGroup;
    setGroup({ ...group, conditions: updated });
  };

  const toggleOperator = () => {
    const next = group.operator === "AND" ? "OR" : "AND";
    setGroup({ ...group, operator: next });
  };

  const handleReset = () => {
    setGroup({ operator: "AND", conditions: [] });
  };

  return (
    <div className="card border p-3 mb-3 bg-light">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong>Group: {group.operator}</strong>
        <div className="btn-group btn-group-sm">
          <button className="btn btn-outline-primary" onClick={toggleOperator}>
            Toggle to {group.operator === "AND" ? "OR" : "AND"}
          </button>
          {!isRoot && (
            <button className="btn btn-outline-danger" onClick={onRemove} disabled={!hasConditions}>
              Remove Group
            </button>
          )}
          <button disabled={!canReset}  className="btn btn-danger ml-3 text-end" onClick={() => onReset()}><i className="fa fa-refresh" aria-hidden="true"></i></button>
          {isRoot && (
            <button className="btn btn-outline-warning" onClick={handleReset}>
              Reset Filters
            </button>
          )}
        </div>
      </div>

      {group.conditions.map((condition, index) => {
        if (condition.conditions) {
          return (
            <ConditionGroup
              key={index}
              group={condition}
              setGroup={(newSubGroup) => handleGroupChange(index, newSubGroup)}
              fields={fields}
              onRemove={() => handleClauseDelete(index)}
            />
          );
        } else {
          return (
            <div key={index} className="mb-2">
              <ClauseBuilder
                clause={condition}
                fields={fields}
                onUpdate={(updated) => handleClauseChange(index, updated)}
                onDelete={() => handleClauseDelete(index)}
              />
            </div>
          );
        }
      })}

      <div className="mt-2 d-flex gap-2">
        <button className="btn btn-secondary btn-sm" onClick={handleAddClause}>
          + Add Condition
        </button>
        <button className="btn btn-warning btn-sm" onClick={handleAddGroup}>
          + Add Group
        </button>
      </div>
    </div>
  );
};

export default ConditionGroup;
